import { cosemApi } from '@services/providers/cosem';
import { ApiResponse } from '@services/providers/cosem.types';

export const coreApi = cosemApi.injectEndpoints({
    endpoints: (build) => ({
        delete: build.mutation<ApiResponse<void>, { entity: string; id: string|number }>({
            query: ({ entity, id }) => {
                return {
                    url: `/core/delete/${entity}/${id}`,
                    method: 'DELETE'
                };
            },
            transformResponse: (response: ApiResponse<void>) => response
        }),
        
    })
});

export const { useDeleteMutation } = coreApi;
